import * as React from 'react';
import styled from 'styled-components';

interface Props {
  color: string;
}

interface StSensorDotProps {
  color: string;
}

const StSensorDot = styled.div`
  display: inline-block;
  min-width: 16px;
  min-height: 16px;
  max-width: 16px;
  max-height: 16px;
  border-radius: 50%;
  background-color: ${(props: StSensorDotProps) => props.color};
`;

class SensorDot extends React.Component<Props> {
  render() {
    const { color } = this.props;

    return <StSensorDot color={color} />;
  }
}

export default SensorDot;



// WEBPACK FOOTER //
// ./src/app/ui/components/SensorDot.tsx